import React, { createContext, useState, useContext, useEffect } from 'react';
import { getMe, setAuthToken as setApiAuthToken, getAuthToken } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      loadUser();
    } else {
      setLoading(false);
    }
  }, []);

  const loadUser = async () => {
    try {
      const userData = await getMe();
      setUser(userData);
    } catch (error) {
      console.error('Failed to load user:', error);
      setApiAuthToken(null);
    } finally {
      setLoading(false);
    }
  };

  const loginUser = (token, userData) => {
    setApiAuthToken(token);
    setUser(userData);
  };

  const logoutUser = () => {
    setApiAuthToken(null);
    setUser(null);
  };

  const value = {
    user,
    loading,
    loginUser,
    logoutUser,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
